import React, { useState } from 'react';
import image1 from '../../../assets/images/trvto_tripDetails.jpg';
import { share } from '../../../pages/tripDetails/tripDetailsFun/tripDetailsShare';
import { ReactComponent as Share } from '../../../assets/icons/trvto_share.svg';
import { toPascalCase } from '../../../utils/pascalCase';
import ReviewStars from '../../reviewStars/ReviewStars';
import Calendar from '../../../assets/icons/trvto_calendar.svg';
import Tooltip from '../../tooltip/Tooltip';
import EditIcon from '../../../assets/icons/trvto_edit_icon.svg';
import DuplicateIcon from '../../../assets/icons/trvto_duplicate.png';
import DeleteIcon from '../../../assets/icons/trvto_deleteIcon.svg';
import { ReactComponent as InactiveIcon } from '../../../assets/icons/inactive-icons.svg';
import { useLocation } from 'react-router-dom';

const OrgTripCard = ({ dataItem, onSelect, onEdit, onDuplicate, onDelete, onInactive, selectedStatus }) => {
    const location = useLocation();

    const isSupport = location.pathname.startsWith('/support');

    const [isDateCreated, setIsDateCreated] = useState(false);
    const handleCardClick = () => {
        onSelect?.(dataItem._id);
    };

    const handleEdit = (event) => {
        event.stopPropagation();
        onEdit?.(dataItem._id);
    };

    const handleDuplicate = (event) => {
        event.stopPropagation();
        onDuplicate?.(dataItem._id);
    };

    const handleDetele = (event) => {
        event.stopPropagation();
        onDelete?.(dataItem._id);
    };

    const handleInactive = (event) => {
        event.stopPropagation();
        onInactive?.(dataItem._id);
    };

    return (
        <div key={dataItem._id} className='org_tripStrap' onClick={handleCardClick}>
            <div className='org_tripStrapContent'>
                <div className='org_thumbImageContainer'>
                    <img
                        src={dataItem?.cardImages?.[0] ?? image1}
                        alt='trvto_trip'
                        className='org_tripStrapImage'
                        loading='lazy'
                        decoding='async'
                    />
                </div>
                <div className='org_tripStrapInfoDiv'>
                    <div className='org_tripStrapNameDiv alignCenter'>
                        <div className='org_tripStrapInfo'>
                            <div className='org_tripStrapName'>
                                <div className='alignCenter'>
                                    <p>{dataItem?.title}</p> <Share className='deskHidden' onClick={(e) => share(e)} />
                                </div>
                                <div className='org_tripInfo'>
                                    {Array.isArray(dataItem?.quickView?.type) &&
                                        dataItem.quickView.type.includes('Trek') && (
                                            <div className='org_typeInfo'>{dataItem.quickView.type[0]}</div>
                                        )}
                                    <div className={`org_typeInfo ${dataItem?.quickView?.difficulty}`}>
                                        {dataItem?.quickView?.difficulty}
                                    </div>{' '}
                                    <div className={`org_typeInfo ${dataItem?.status === 'active' ? 'active' : ''}`}>
                                        {toPascalCase(dataItem?.status || ' ')}
                                    </div>
                                    <Share className='mobileHidden' onClick={(e) => share(e)} />
                                </div>
                            </div>
                            <div className='org_tripCardNumInfo'>
                                <ReviewStars rating={dataItem?.rating} />
                                <span>{dataItem?.rating}</span>
                                <p style={{ margin: 0 }}>({dataItem?.reviewCount} Reviews)</p>
                            </div>
                            {Array.isArray(dataItem.quickView?.type) && dataItem.quickView.type.includes('Trek') && (
                                <div className='org_tripStrapDateDetails'>
                                    <div className='alignCenter'>
                                        <img src={Calendar} width={24} height={24} alt='trvto_calendar' />
                                        <span>
                                            {dataItem?.days} D, {dataItem?.nights} N
                                        </span>
                                        <div className='divider' />
                                        <span className='innerStrap'>
                                            <span className='innerStrapColumn'>
                                                <span>{dataItem?.quickView?.startTime}</span>
                                                <label>|</label>
                                                <span>{dataItem?.quickView?.endTime}</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='org_tripStrapPriceDiv'>
                            <div className='org_tripStrapPrDiv'>
                                <p className='org_tripStrapPrice'>
                                    ₹ {dataItem?.price?.[0]?.total}
                                    <span>/person</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='editDeleteBtn'>
                    <button className='org_tripEdit' onClick={handleDuplicate}>
                        <Tooltip content={'Duplicate'} position='bottom' className='tooltip-large'>
                            <img src={DuplicateIcon} alt='edit' width={36} height={36} />
                        </Tooltip>
                    </button>
                    <button className='org_tripEdit' onClick={handleEdit}>
                        <Tooltip content={'Edit'} position='bottom' className='tooltip-large'>
                            <img src={EditIcon} alt='edit' width={36} height={36} />
                        </Tooltip>
                    </button>
                    {isSupport && (
                        <>
                            <button className='org_tripEdit' onClick={handleDetele}>
                                <Tooltip content={'Delete'} position='bottom' className='tooltip-large'>
                                    <img src={DeleteIcon} alt='delete' width={36} height={36} />
                                </Tooltip>
                            </button>
                            {selectedStatus === 'active' && (
                                <button className='org_tripEdit' onClick={handleInactive}>
                                    <Tooltip content={'Inactive'} position='bottom' className='tooltip-large'>
                                        <InactiveIcon width={36} height={36} color='#EF4444 ' />
                                    </Tooltip>
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
            <div className='orgCreateDateContainer'>
                <button
                    className='orgCreateDate'
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsDateCreated((prev) => !prev);
                    }}
                >
                    Create Date
                </button>
            </div>
            <div>
                {Array.isArray(dataItem.quickView?.type) && dataItem.quickView.type.includes('Trek') && (
                    <>
                        <div className='org_tripDivider org_holidayDivider' />
                        <p className='org_locationInfo'>
                            Pickup Cities: <span>{dataItem?.quickView?.baseCities}</span>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default OrgTripCard;
